export default function HorizontalGauge(props: { value: number }) {
    const { value } = props;
  return (
    <div className="w-24 h-5 relative">
      <div className="flex h-full rounded-full overflow-hidden">
        <div className="flex-1 bg-orange-200 border-r border-white"></div>
        <div className="flex-1 bg-blue-200 border-r border-white"></div>
        <div className="flex-1 bg-green-200"></div>
      </div>
      <div
        className="absolute top-0 bottom-0 w-0.5 bg-gray-800 transition-all duration-300"
        style={{ left: `${value}%`, transform: "translateX(-50%)" }}
      />
    </div>
  );
}
